import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=48ad45b8&scoped=true"
import script from "./highlight.vue?vue&type=script&lang=js"
export * from "./highlight.vue?vue&type=script&lang=js"
import style0 from "./highlight.vue?vue&type=style&index=0&id=48ad45b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ad45b8",
  null
  
)

export default component.exports